import request from "@/utils/request";

//上传图片
export function upload(data) {
  return request({
    url: "/utils/upload",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data,
  });
}

//登录
export function loginAdm(data) {
  return request({
    url: "/adm/login",
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data,
  });
}

//查询首页数据
export function countData() {
  return request({
    url: "/adm/count",
    method: "get",
  });
}

/*
  用户管理操作API
*/

//查询所有用户
export function queryUserList(params) {
  return request({
    url: "/adm/users/all",
    method: "get",
    params,
  });
}

//修改指定用户信息
export function updateByUserInfo(data) {
  return request({
    url: "/adm/users/info",
    method: "put",
    data,
  });
}

//查询指定用户的积分明细
export function queryUserIntegral(params) {
  return request({
    url: "/adm/users/integral",
    method: "get",
    params,
  });
}

//获取指定用户的地址
export function queryUserAddress(params) {
  return request({
    url: "/adm/users/address",
    method: "get",
    params,
  });
}

//通过手机号进行搜索
export function querySearchUserPhone(params) {
  return request({
    url: "/adm/users/search",
    method: "get",
    params,
  });
}

//管理员给指定用户调整积分
export function adjustUserIntegral(data) {
  return request({
    url: "/adm/users/integral/adjust",
    method: "post",
    data,
  });
}

/**
 *   商品管理操作API
 */

//查询所有分类
export function queryClassifys() {
  return request({
    url: "/adm/classify",
    method: "get",
  });
}

//查询指定父分类下的二级分类
export function querySubClassifys(parentId) {
  return request({
    url: `/adm/classify/${parentId}`,
    method: "get",
  });
}

//添加分类
export function addClassify(data) {
  return request({
    url: "/adm/classify",
    method: "post",
    data,
  });
}

//修改指定分类
export function updateClassify(data) {
  return request({
    url: "/adm/classify",
    method: "put",
    data,
  });
}

//删除指定的分类
export function delClassify(id) {
  return request({
    url: `/adm/classify/${id}`,
    method: "delete",
  });
}

//查询所有商品
export function queryGoods(params) {
  return request({
    url: "/adm/goods",
    method: "get",
    params,
  });
}

//搜索商品
export function querySearchGoods(params) {
  return request({
    url: "/adm/goods/search",
    method: "get",
    params,
  });
}

//添加商品
export function addGood(data) {
  return request({
    url: "/adm/goods",
    method: "post",
    data,
  });
}

//修改指定商品
export function updateByGood(data) {
  return request({
    url: "/adm/goods",
    method: "put",
    data,
  });
}

//删除指定商品
export function deleteByGood(params) {
  return request({
    url: "/adm/goods",
    method: "delete",
    params,
  });
}

/*
  订单管理api
 */

//查询所有订单
export function queryOrders(params) {
  return request({
    url: "/adm/orders",
    method: "get",
    params,
  });
}

//搜索订单
export function querySearchOrders(params) {
  return request({
    url: "/adm/orders/search",
    method: "get",
    params,
  });
}



//操作发货
export function putOrdersShipment(data) {
  return request({
    url: "/adm/orders/shipment",
    method: "put",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data,
  });
}

//操作退款
export function putOrdersRefund(data) {
  return request({
    url: "/adm/orders/refund",
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data,
  });
}

//拒绝退款
export function putOrdersNoRefund(data) {
  return request({
    url: "/adm/orders/noRefund",
    method: "put",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data,
  });
}

//确认完成
export function postOrderAccomplish(data){
  return request({
    url: "/adm/orders/accomplish",
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data,
  });
}

//核销提货
export function postOrderVerify(data){
  return request({
    url: "/adm/orders/verify",
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data,
  });
}

/*
  买家秀api管理
 */

//获取所有买家秀
export function queryShows(params) {
  return request({
    url: "/adm/shows",
    method: "get",
    params,
  });
}

//添加买家秀
export function addShow(data) {
  return request({
    url: "/adm/shows",
    method: "post",
    data,
  });
}

//修改指定买家秀
export function updateSetShows(data) {
  return request({
    url: "/adm/shows",
    method: "put",
    data,
  });
}

//删除指定买家秀
export function deleteByShows(id) {
  return request({
    url: `/adm/shows/${id}`,
    method: "delete",
  });
}

//获取配置信息
export function querySystems() {
  return request({
    url: "/system",
    method: "get",
  });
}

//修改指定的配置信息
export function updateSystems(data) {
  return request({
    url: "/adm/system",
    method: "put",
    data,
  });
}

// 获取所有区域
export function queryFreights(params) {
  return request({
    url: "/adm/freights",
    method: "get",
    params,
  });
}

//添加区域
export function addFreights(data) {
  return request({
    url: "/adm/freights",
    method: "post",
    data,
  });
}

//修改指定区域
export function updateFreights(data) {
  return request({
    url: "/adm/freights",
    method: "put",
    data,
  });
}

//删除指定区域
export function deleteFreights(id) {
  return request({
    url: `/adm/freights/${id}`,
    method: "delete"
  });
}

//获取配送时间段列表
export function getDeliveryTimeSlots() {
  return request({
    url: "/adm/deliveryTimeSlots",
    method: "get",
  });
}

//保存配送时间段（写入 system_config）
export function saveDeliveryTimeSlots(data) {
  return request({
    url: "/adm/system",
    method: "put",
    data,
  });
}
